import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=b3eaa4b4&scoped=true"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eaa4b4",
  null
  
)

export default component.exports